module.exports = __webpack_public_path__ + "img/cartaz.830ca4db.jpg";